import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Clases organizadas y listas para usar',
  value: '15',
  desc: 'Material estructurado para que el docente pueda enseñar sin empezar desde cero, con contenidos ordenados por módulos y temas según la progresión del año.',
  benefit: 'Entrás al aula con todo pensado y todo listo. Sin improvisar nunca más.'
}, {
  id: '02',
  title: 'Actividades prácticas para el aula y el taller',
  value: '12',
  desc: 'Propuestas aplicables para que los estudiantes trabajen los contenidos de forma práctica, técnica y relacionada con situaciones reales del campo.',
  benefit: 'Nunca más perdés el hilo entre la teoría y la práctica agropecuaria.'
}, {
  id: '03',
  title: 'Evaluaciones y criterios de corrección',
  value: '10',
  desc: 'Incluye evaluaciones multiple choice, evaluaciones formales y criterios de corrección para facilitar el seguimiento del aprendizaje.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión.'
}, {
  id: '04',
  title: 'Proyectos Finales Productivos',
  value: '9',
  desc: 'Proyectos integradores para que los estudiantes puedan aplicar lo aprendido en propuestas reales de producción, vivero, comercialización y gestión agropecuaria.',
  benefit: 'El cierre que todo docente técnico necesita para terminar el año con impacto real.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-earth/20" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-forest font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-19">
            🎁 Los 4 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream border border-earth/20 rounded-2xl p-8 relative group hover:border-forest/40 transition-colors shadow-sm" data-id="element-21">
              <div className="absolute top-0 right-0 bg-forest/10 text-forest px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-forest/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-forest/10 rounded-full flex items-center justify-center text-forest mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-slate-900" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white px-3 py-1 rounded mb-4 border border-earth/10" data-id="element-26">
                <span className="text-slate-500 text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-forest font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-slate-600 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-earth text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-forest-light/10 via-forest/5 to-forest-light/10 border border-forest/20 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-slate-600 mb-2" data-id="element-33">Valor total de los 4 bonos</p>
          <p className="text-2xl text-slate-400 line-through mb-4" data-id="element-34">USD 46,00</p>
          <p className="text-lg text-slate-800 mb-2 font-medium" data-id="element-35">
            Tu precio hoy
          </p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-forest font-medium" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}